import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWikiLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 122,
	height: 122,
	viewBox: "0 0 122 122",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "wiki_logo",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "shape",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M57.7468 54.4934V89.9547C43.1068 88.328 31.7201 75.9652 31.7201 60.9999C31.7201 52.2159 35.6241 44.0828 42.1309 38.8773L57.7468 54.4934Z",
					fill: "#118AB2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.2799 60.9999C90.2799 75.9652 78.8933 88.6531 64.2533 89.9547V54.4934L79.8692 38.8773C86.376 44.0828 90.2799 52.2159 90.2799 60.9999Z",
					fill: "#118AB2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.8587 24.8881L84.7493 33.9971C92.232 40.5039 96.7867 50.2638 96.7867 60.9998C96.7867 80.8449 80.8454 96.7862 61.0002 96.7862C41.1546 96.7862 25.2133 80.8449 25.2133 60.9998C25.2133 50.2638 30.0934 40.8293 37.2507 33.9971L28.1413 24.8881C18.3814 33.9971 12.2 46.6853 12.2 60.9998C12.2 88.0022 33.9973 109.8 61.0002 109.8C88.0027 109.8 109.8 88.0022 109.8 60.9998C109.8 46.6853 103.619 33.9971 93.8587 24.8881Z",
					fill: "#118AB2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M60.9998 44.7332C69.9836 44.7332 77.2666 37.4503 77.2666 28.4666C77.2666 19.4828 69.9836 12.2 60.9998 12.2C52.016 12.2 44.7331 19.4828 44.7331 28.4666C44.7331 37.4503 52.016 44.7332 60.9998 44.7332Z",
					fill: "#118AB2"
				})
			]
		})
	})
});
export default SvgWikiLogo;
